/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";
import { Outlet } from "react-router-dom";

/**
 * Layout wrapper for pre-auth routes (SplashScreen, SignIn).
 * Renders child routes via Outlet.
 */
const AuthLayout: FunctionComponent = (): JSX.Element => {
  return <Outlet />;
};

export default AuthLayout;
